import { useState } from "react"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import React from "react"
import PrivacyPolicy from "../../../components/AdminPortalComponents/WebAndAppManagement/PageSetup/PrivacyPolicy"
import DynamicSquaredFilterBar from "../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import TermsAndConditions from "../../../components/AdminPortalComponents/WebAndAppManagement/PageSetup/TermsAndConditions"
import CookiesPolicy from "../../../components/AdminPortalComponents/WebAndAppManagement/PageSetup/CookiesPolicy"
import ReturnPolicy from "../../../components/AdminPortalComponents/WebAndAppManagement/PageSetup/ReturnPolicy"
import PurchaseProtection from "../../../components/AdminPortalComponents/WebAndAppManagement/PageSetup/PurhaseProtection"

const PageSetup = () => {
  const tabs = [
    { key: "privacyPolicy", label: "Privacy Policy" },
    { key: "termsAndConditions", label: "Terms & Conditions" },
    { key: "cookiesPolicy", label: "Cookies Policy" },
    { key: "returnPolicy", label: "Return Policy" },
    { key: "purchaseProtection", label: "Purchase Protection" },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const renderTab = {
    privacyPolicy: <PrivacyPolicy />,
    termsAndConditions: <TermsAndConditions />,
    cookiesPolicy: <CookiesPolicy />,
    returnPolicy: <ReturnPolicy />,
    purchaseProtection: <PurchaseProtection />,
  }

  return (
    <LightGrayBgWrapper>
     <div className="shadow">
      <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      {renderTab[activeTab] || null}
    </LightGrayBgWrapper>
  )
}

export default PageSetup
